import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { Location } from 'ngx-place-picker/lib/location';

@Component({
  selector: 'app-location-input',
  templateUrl: './location-input.component.html',
  styleUrls: ['./location-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: LocationInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: LocationInputComponent,
    },
  ],
})
export class LocationInputComponent implements ControlValueAccessor, Validator {
  selectedLocation?: Location;

  @Input()
  title = 'Search location...';

  @Input()
  iconName: string = 'geo-alt fw-semibold';

  @Input()
  isDisabled = false;

  @Input()
  showIcon = true;

  @Input()
  enableCurrentLocation = false;

  constructor() {
  }

  ngOnInit(): void { }

  onChange = (option: Location | undefined) => { };

  onTouched = () => { };

  touched = false;

  disabled = false;


  writeValue(option: Location) {
    this.selectedLocation = option;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const option = control.value;
    return null;
  }


  locationChange($event: Location) {
    this.markAsTouched();
    this.selectedLocation = $event;
    this.onChange(this.selectedLocation);
    console.log($event);
  }
}
